// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Label/Label.less
// module id = 217
// module chunks = 2